import { Route, Routes } from 'react-router-dom';
import './App.css';
import LoginPage from './pages/LoginPage';
import RouterPage from './pages/RouterPage';
import ProtectedRoute from './components/ProtectedRoute';




function App() {
  return (
    <div>
    <Routes>
        <Route path='/' element={  <LoginPage />} />
        <Route path='/*' element={<ProtectedRoute><RouterPage /></ProtectedRoute> } />
    </Routes>
    </div>
  );
}

export default App;
